@import "../../conversational-search-partials/processing/processing.scss";
@import "../../../../../styles/variables";

.conversational-search-mediators-wrapper {
  margin: 0 auto;
  overflow: hidden;
  max-width: 800px;

  @media (max-width: 1100px) {
    margin: 0 12.5%;
  }

  @media (max-width: $uiaas-tablet) {
    margin: 0 16px;
  }
}
